<script setup lang="ts">
import { useTemplateRef } from 'vue';
import { useI18n } from 'vue-i18n';
import { AkButton, AkIcon, AkModal } from '@ankorstore/design-system';
import AddToCartPopin from '@monolith/legacy/components/popins/add-to-cart-popin.vue';

defineProps<{
  productId: number;
  userIsBrand: boolean;
}>();

const emit = defineEmits<{
  selectClick: [];
  variantAdded: [payload: unknown];
  variantModalClosed: [];
}>();

const { t } = useI18n();

const quickAddToCartModal = useTemplateRef<InstanceType<typeof AkModal>>('quickAddToCartModal');

const openModal = () => {
  quickAddToCartModal.value?.openModal();
};

defineExpose({ openModal });
</script>

<template>
  <div class="qatc-multi-variant">
    <AkButton
      color="white"
      outlined
      size="lg"
      type="button"
      class="qatc-multi-variant__button"
      :disabled="userIsBrand"
      data-testid="addToCartButton"
      @click="emit('selectClick')"
    >
      <AkIcon
        size="md"
        symbol="cart"
        class="qatc-multi-variant__button-icon"
      />
      {{ t('discovery.qatc.selectOptions') }}
    </AkButton>
    <Teleport to="body">
      <AkModal
        ref="quickAddToCartModal"
        size="xl"
        :with-padding="false"
        data-testid="addToCartModal"
        @cancelled="emit('variantModalClosed')"
      >
        <AddToCartPopin
          :product-id="productId"
          @add-to-cart-variant="emit('variantAdded', $event)"
        />
      </AkModal>
    </Teleport>
  </div>
</template>

<style lang="scss" scoped>
.qatc-multi-variant {
  @apply ds-mt-3;

  &__button {
    @apply ds-w-full;
  }

  &__button-icon {
    @apply ds-mr-2;
  }

  :deep(.ak-button) {
    @apply ds-text-wrap md:ds-text-nowrap ds-leading-4;
  }
}
</style>
